var map = {
	"./Currency-Exchange-Plugin.jpeg": 238,
	"./Google-Book-Library.jpeg": 358,
	"./NYT-Book-Reviews.jpeg": 983,
	"./Wordpicker.jpeg": 517,
	"./Your-Weight-On-All-Planets.jpeg": 985,
	"./additional-product-image.jpeg": 430,
	"./content-management-system.jpeg": 326,
	"./nscc-logo.jpeg": 88,
	"./patient-data-diary.jpeg": 196,
	"./patient-diary.jpeg": 652,
	"./python-data-scrapper.jpeg": 536,
	"./quick-quran-ref.jpeg": 810,
	"./quick-quran-reference.jpeg": 798,
	"./responsive-grid-layout.jpeg": 223,
	"./shoaib_khalid.jpeg": 441,
	"./travel-and-adventure.jpeg": 518,
	"./tshirt-quote-plugin.jpeg": 100,
	"./velsoft-logo.jpeg": 917,
	"./wordpicker-lms.jpeg": 608,
	"./wp-rest-api.jpeg": 237
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 122;